import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import { ButtonWrapper } from '../../SerpMonitoring.styles';
import Loading from '@/common/components/Loading';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import StringListField from './components/StringListField';
import useSerpMonitoringForm from './useSerpMonitoringForm';
import { Form, InputsContainer, Splitter, Title } from './SerpMonitoringForm.styles';
import { SERP_MONITORING_ADD_TO_GRADE_LABEL } from '@/common/constants/serpMonitoring';

const SerpMonitoringForm = ({
	setShow,
	selectedConfig,
	reload = () => {},
}) => {
	const {
		formik,
		productOptions,
		marketsOptions,
		keyWords,
		setKeyWords,
		gradeKeyWords,
		setGradeKeyWords,
		blacklistWords,
		setBlacklistWords,
		platformLinks,
		setPlatformLinks,
		isLoading,
		handleMarketChange,
	} = useSerpMonitoringForm({ setShow, selectedConfig, reload });

	return (
		<PopUp setShow={setShow}>
			{isLoading && <Loading />}
			<Form onSubmit={formik.handleSubmit}>
				<Title>SERP Monitoring config edit</Title>
				<InputsContainer>
					<SelectInput
						color={Colors.darkBlue}
						name='Market'
						required
						hideStar
						options={marketsOptions}
						width={100}
						setSelected={handleMarketChange}
						selected={formik.values.market}
						value={formik.values.market}
					/>
					<SelectInput
						color={Colors.darkBlue}
						name='Product'
						required
						hideStar
						options={productOptions}
						width={100}
						setSelected={(value) => formik.setFieldValue('product', value)}
						selected={formik.values.product}
						value={formik.values.product}
						disabled={!formik.values.market}
					/>
				</InputsContainer>
				<Splitter />
				<Input
					id='googleDriveId'
					inputName='googleDriveId'
					color={Colors.darkBlue}
					name='Google Drive ID'
					required
					width={100}
					value={formik.values.googleDriveId}
					onChange={formik.handleChange}
				/>
				<Splitter />
				<Input
					id='language'
					inputName='language'
					color={Colors.darkBlue}
					name='Language'
					required
					width={100}
					value={formik.values.language}
					onChange={formik.handleChange}
				/>
				<Input
					id='gl'
					inputName='gl'
					color={Colors.darkBlue}
					name='Country code'
					required
					width={100}
					value={formik.values.gl}
					onChange={formik.handleChange}
				/>
				<Input
					id='lr'
					inputName='lr'
					color={Colors.darkBlue}
					name='Language restriction'
					required
					width={100}
					value={formik.values.lr}
					onChange={formik.handleChange}
				/>
				<Input
					id='location'
					inputName='location'
					color={Colors.darkBlue}
					name='Location'
					required
					width={100}
					value={formik.values.location}
					onChange={formik.handleChange}
				/>
				<Input
					id='googleDomain'
					inputName='googleDomain'
					color={Colors.darkBlue}
					name='Google domain'
					required
					width={100}
					value={formik.values.googleDomain}
					onChange={formik.handleChange}
				/>
				<Splitter />
				<StringListField
					title='Key words'
					values={keyWords}
					setValues={setKeyWords}
					selectedValues={gradeKeyWords}
					setSelectedValues={setGradeKeyWords}
					selectLabel={SERP_MONITORING_ADD_TO_GRADE_LABEL}
				/>
				<Splitter />
				<StringListField
					title='Blacklist words'
					values={blacklistWords}
					setValues={setBlacklistWords}
				/>
				<Splitter />
				<StringListField
					title='Platform links'
					values={platformLinks}
					setValues={setPlatformLinks}
				/>
				<ButtonWrapper>
					<SubmitButton
						style={{ marginBottom: '-30px' }}
						text='Save'
						disabled={isLoading}
					/>
				</ButtonWrapper>
			</Form>
		</PopUp>
	);
};

export default SerpMonitoringForm;
